import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const MeetingsViewAttendanceIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="8.25"
      stroke="currentColor"
      strokeWidth="1.75"
    />
    <path
      d="M8 12.25L10.75 15L16.25 9"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
